import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {useGelboxTooltipControls} from './GelboxTooltip.utils';
import {ControlButtons, ControlTooltip} from '../../ControlTooltip';

export function GelboxTooltip(props) {
  const {t} = useTranslation();

  const [controlItems, setControlItems] = React.useState([]);

  const {getControlItems} = useGelboxTooltipControls();

  const tooltipStyle = () => {
   let style = {top: '0px', left: '50%', transform: 'translateX(-50%)'};
   if(!props.showControls){
     style.top = '35px';
   }
   if (props.open) {
     style.top = '-90px';
   }
   return style;
 };

  React.useEffect(() => {
    setControlItems(getControlItems(props));
  }, [props.volume, props.open, props.containsGel]);

  return (
    <ControlTooltip
      label={t('GelElectrophoresisBox.string')}
      showControls={props.showControls}
      tooltipStyle={tooltipStyle()}>
      <ControlButtons buttonList={controlItems} />
    </ControlTooltip>
  );
}

GelboxTooltip.propTypes = {
  /**
   * Booolean to set if contols tooltip should be displayed
   */
  showControls: PropTypes.bool,

  /**
   * Boolean to specify if lid Open
   */
  open: PropTypes.bool,
  volume: PropTypes.int,
  containsGel: PropTypes.bool,
  /**
   * Function to invoke on Clicking config menu
   */
  openShowOrientationModal: PropTypes.func,
  /**
   * Function to invoke on Clicking config menu
   */
  openShowGelPipetteModal: PropTypes.func,
  /**
   * Function to open/close Lid
   */
  toggleLid: PropTypes.func,
  /**
   * Funciton to eject all tubes
   */
  onEjectGel: PropTypes.func,
  /**
   * Function to open Balance Solution Modal
   */
  openBalanceModal: PropTypes.func,
};

GelboxTooltip.defaultProps = {
  showControls: false,
};
